import React, { FunctionComponent } from "react"
import Grid from "../../components/Grid/Grid"
import LinkItem from "../../components/Grid/LinkItem"
import Loader from "../../components/Loader/Loader"
import Seo from "../../components/Seo/Seo"
import { iArTarget, iArTargetQuery } from "../../definitions/ArTarget"
import { useData } from "../../hooks/useData"
import ArTargetItem from "./Item"

const ArTargets: FunctionComponent = () => {
  const { loading, data, total } = useData<iArTargetQuery, iArTarget>({
    link: "/v1/ar-targets",
    defaultQuery: {},
    shouldPushQuery: true,
  })

  return (
    <>
      <Seo title="Ar Targets" />
      <div className="content">
        <div className="content-header">
          <h1>Ar Targets ({total})</h1>
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : data.length ? (
        <div className="grid-wrap">
          <Grid>
            {data.map((d, i) => (
              <LinkItem key={i} url={"/ar-targets/" + d.url}>
                <ArTargetItem {...d} />
              </LinkItem>
            ))}
          </Grid>
        </div>
      ) : (
        <div className="no-data">No matching results.</div>
      )}
    </>
  )
}

export default ArTargets
